import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { InventoryDocumentKind, SaleDocumentKind } from '@skylab-shared/dataModel';

export interface PrintingPatternItem {
    readonly id: number;
    readonly default: boolean;
    readonly disableShadows: boolean;
    readonly kind: SaleDocumentKind | InventoryDocumentKind;
    readonly name: string;
}

export class PrintingPatternQuery extends Query<PrintingPatternItem[]> { }

export class PrintingPatternQueryHandlerBase implements QueryHandler<PrintingPatternQuery, PrintingPatternItem[]> {
    private static Url = TaggedUrl.join('documents/printingTemplates', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: PrintingPatternQuery): Promise<PrintingPatternItem[]> {
        const { data } = await this.http.get<{ items: PrintingPatternItem[] }>(PrintingPatternQueryHandlerBase.Url);
        return data.items;
    }
}
